import { Button } from "@/domains/shared/components/Button";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Roles } from "@/domains/shared/models/roles";
import { api } from "@/domains/shared/services/api";
import { Link } from "react-router";
import { toast } from "sonner";

export default function EmailVerificationBanner() {
    const { user } = useAuth();
    if (!user || user.role === Roles.Admin || user.emailVerified === true) {
return null;
}

    const resend = async () => {
        try {
            await api.post("/auth/verify-email/request");
            toast.success("Enviamos um novo código para o seu e-mail.");
        } catch (e: unknown) {
            const detail =
                e && typeof e === "object" && "response" in e
                    ? (e as { response?: { data?: { detail?: string } } }).response?.data?.detail
                    : null;
            toast.error(detail || "Não foi possível reenviar o código.");
        }
    };

    return (
        <div
            className="shrink-0 border-b border-sky-200 bg-sky-50 px-4 py-3 md:px-8 text-sm text-primary"
            data-testid="email-verification-banner"
        >
            <p className="leading-relaxed">
                <span className="font-bold">Confirme seu e-mail</span> para usar a plataforma, alterar a senha e vincular profissionais pelo
                código de convite.{" "}
                <Link to="/verificar-email" className="font-bold text-secondary-foreground underline underline-offset-2">
                    Verificar agora
                </Link>
            </p>
            <div className="mt-2 flex flex-wrap gap-2">
                <Button type="button" size="sm" variant="outline" onClick={resend}>
                    Reenviar código
                </Button>
            </div>
        </div>
    );
}

